import { useEffect, useRef } from 'react';

export function useStopClickPropagation<T extends HTMLElement>(onClick?: (event: MouseEvent) => void) {
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handler = (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      onClickRef.current?.(event);
    };

    element.addEventListener('click', handler);
    return () => element.removeEventListener('click', handler);
  }, []);

  return ref;
}
